<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      class="purchaseReceivingEdit"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : pkid > 0 ? '编辑' : '新建 ' "
      width="1000px"
      top="5vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        class="form"
        :disabled="disabled"
        :model="filter"
        :rules="ruleValidate"
        label-width="100px"
    >
      <el-row>
        <el-col v-if="pkid > 0" :span="12">
          <el-form-item label="单据编号" prop="billNO">
            <el-input v-model="filter.billNO" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="采购单号" prop="purchaseOrderNo">
            <el-input v-model="filter.purchaseOrderNo"/>
          </el-form-item>
        </el-col>
        <el-col v-if="pkid > 0" :span="12">
          <el-form-item label="收货时间" prop="receiptTime">
            <el-input v-model="filter.receiptTime" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供应商" prop="supplierName">
            <el-input v-model="filter.supplierName" placeholder="请选择供应商">
              <el-button slot="append" @click="$refs.supplierSelect.open()"> 选择 </el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="pkid > 0" :span="12">
          <el-form-item label="制单时间" prop="createTime">
            <el-input v-model="filter.createTime" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="pkid > 0" :span="12">
          <el-form-item label="制单人" prop="creatorName">
            <el-input v-model="filter.creatorName" disabled/>
          </el-form-item>
        </el-col>
      </el-row>     
      <div class="editTitle">收货明细</div>
      <el-button
          v-if="!disabled"
          type="primary"
          style="margin-bottom: 10px"
          @click="$refs.materialSelect.open(20)">
        添加
      </el-button>
      <el-table
          class="tableBox"
          :data="filter.billDetails"
          border>
        <el-table-column 
            prop="materialNo" 
            align="center" 
            label="物料编号" 
            show-overflow-tooltip 
            width="120"/>
        <el-table-column 
            prop="materialName" 
            align="center" 
            label="物料描述" 
            show-overflow-tooltip 
            width="120"/>
        <el-table-column prop="specification" align="center" label="规格型号" width="120"/>
        <el-table-column prop="unitName" align="center" label="单位" width="55"/>
        <el-table-column align="center" label="数量" width="100" prop="receiptQuantity">
          <template slot-scope="scope">
            <el-form-item :prop="'billDetails.' + scope.$index + '.receiptQuantity'" :rules="ruleValidate.receiptQuantity">
              <el-input v-model="scope.row.receiptQuantity" placeholder="请输入" @change="quantityChange(scope.row,scope.$index)"/>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column align="center" label="最小包装数" width="100">
          <template slot-scope="scope">
            <el-form-item :prop="'billDetails.' + scope.$index + '.minPackageQuantity'" :rules="ruleValidate.minPackageQuantity">
              <el-input v-model="scope.row.minPackageQuantity" :disabled="scope.row.materialTypeName === '钢卷'" @change="checkMaterialAmount(scope.row)"/>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column align="center" label="装箱数量" width="80">
          <template slot-scope="scope">
            <el-form-item :prop="'billDetails.' + scope.$index + '.boxQuantity'" :rules="ruleValidate.boxQuantity">
              <el-input v-model="scope.row.boxQuantity" :disabled="scope.row.materialTypeName === '钢卷'"/>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column align="center" label="标签数" width="70">
          <template slot-scope="scope">
            <span v-if="scope.row.minPackageQuantity <= 0 || scope.row.receiptQuantity <= 0 ">0</span>
            <span v-else>{{Math.ceil(((scope.row.receiptQuantity)/(scope.row.minPackageQuantity)))}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="箱标签数" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.boxQuantity <=0 ||scope.row.receiptQuantity <= 0 || scope.row.minPackageQuantity <= 0">0</span>
            <span v-else>{{Math.ceil((((scope.row.receiptQuantity)/(scope.row.minPackageQuantity))/(scope.row.boxQuantity)))}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="生产日期" width="150">
          <template slot-scope="scope">
            <el-date-picker
                v-model="scope.row.manufactureDate"
                type="date"
                style="width:100%"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择日期"/>
          </template>
        </el-table-column>
        <el-table-column align="center" label="失效日期" width="150">
          <template slot-scope="scope">
            <el-date-picker
                v-model="scope.row.expiredDate"
                type="date"
                style="width:100%"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择日期"/>
          </template>
        </el-table-column>
        <el-table-column align="center" label="备注" width="160">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.note"
                type="textarea"
                autosize
                placeholder="请输入物料备注"
                clearable/>
          </template>
        </el-table-column>
        <el-table-column v-if="!disabled" label="操作" align="center" prop="action">
          <template slot-scope="scope">
            <el-button type="danger" @click="deleteMaterial(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <material-select ref="materialSelect" @select="materialSelect"/>
    <supplier-select ref="supplierSelect" @select="supplierSelect"/>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button 
          v-if="!disabled"
          :disabled="AmountCorrect"
          type="primary"
          :loading="submitLoading"
          @click="handleSubmit">
        确定
      </el-button>
    </div>
  </el-dialog> 
</template>
<script>
  import MaterialSelect from "../../information/Material/MaterialSelect";
  import SupplierSelect from "../../information/SupplierManage/SupplierSelect";
  export default {
    name:"PurchaseReceivingEdit",
    components:{ MaterialSelect, SupplierSelect },
    data() {
      let checkInt = (rule,value,callback)=>{
        if(Number(value) && value % 1 === 0 && value >= 0) {
          callback();
        }else {
          return callback(new Error("请输入正整数！"));
        }
      };
      return {
        dialogVisible:false,
        submitLoading:false,
        contentLoading:false,
        pkid:"",
        disabled:false,
        flag:false,
        AmountCorrect:false,
        filter:{
          billNO:"",
          purchaseOrderNo:"",
          supplierId:"",
          supplierName:"",
          receiptTime:"",
          createTime:"",
          creatorName:"",
          billDetails:[],
        },
        ruleValidate:{
          purchaseOrderNo: {required: true, message: "不能为空"},
          supplierName: {required:true, message:"请选择供应商"},
          receiptQuantity: { pattern: /^\d+(.\d{1,2})?$/, required: true, trigger: "blur"},
          minPackageQuantity: {required:true, trigger: "blur", validator: checkInt},
          boxQuantity: { pattern:/^([1-9]\d*|[0]{1,1})$/,  required: true, trigger: "blur"},
        },
      };
    },
    methods:{
      //页面开启
      open(id,disabled) {
        this.pkid = id;
        this.dialogVisible = true;
        if(this.pkid > 0) {
          this.getData();
        }else {
          this.getBillNO();
        }
        if(disabled) {
          this.disabled = true;
        }
      },

      //获取下一个可用的订单号
      getBillNO() {
        this.$http.get("basic","deliveryBills/getBillNO").then((res)=>{
          this.filter.billNO = res.data;
        }).catch(()=>{

        });
      },

      //编辑时获取已有数据
      getData() {
        this.$http.get("basic",`deliveryBills/${this.pkid}`).then((res)=>{
          console.log(res);
          this.filter = res.data;
        });
      },

      //供应商选择
      supplierSelect(row) {
        console.log(row);
        this.filter.supplierName = row.name;
        this.filter.supplierId = row.pkid;
      },

      //物料选择
      materialSelect(row) {
        console.log(row);
        this.flag = false;
        console.log(row.materialTypeName);
        let MaterialDetail = {};
        if(row.materialTypeName === "钢卷") {
          MaterialDetail = {
            receiptQuantity:"",
            minPackageQuantity:"",
            boxQuantity:0,
            manufactureDate: "",
            expiredDate: "",
            materialId:row.materialID,
            materialName: row.materialName,
            materialTypeName: row.materialTypeName,
            materialNo: row.materialNO,
            unitName: row.unitName,
            specification: row.specification,
            note: row.note,
          };
          this.flag = true;
        }else{
          MaterialDetail = {
            receiptQuantity:"",
            minPackageQuantity:1,
            boxQuantity:0,
            manufactureDate: "",
            expiredDate: "",
            materialId:row.materialID,
            materialName: row.materialName,
            materialTypeName: row.materialTypeName,
            materialNo: row.materialNO,
            unitName: row.unitName,
            specification: row.specification,
            note: row.note,
          };
        }
        this.filter.billDetails.push(MaterialDetail);
      },

      //删除物料
      deleteMaterial(index) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.filter.billDetails.splice(index,1);
        });
      },

      //检测数量是否可以整除最小包装数
      checkMaterialAmount(row) {
        if(row.receiptQuantity % row.minPackageQuantity !== 0) {
          this.$message.error("当前存在零散物料,请添加新的行项！");
          this.AmountCorrect = true;
        }else{
          this.AmountCorrect = false;
        }
      },

      //当物料类型为钢卷时，
      quantityChange(row,num) {
        if(row.materialTypeName === "钢卷") {
          this.filter.billDetails[num].minPackageQuantity = this.filter.billDetails[num].receiptQuantity;
        }
      },

      //提交表单数据
      handleSubmit() {
        let flag = false;
        this.filter.billDetails.forEach(item=>{
          let a = parseInt(item.receiptQuantity);
          let b = parseInt(item.minPackageQuantity);
          flag = (a < b) ? true : false ; 
        });
        console.log(flag);
        if(flag) {
          this.$message.error("最小包装数不得大于数量！");
          return;
        }
        console.log(this.filter);
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "deliveryBills", this.filter)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
<style lang="scss">
.purchaseReceivingEdit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.purchaseReceivingEdit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.purchaseReceivingEdit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.purchaseReceivingEdit .el-divider--horizontal {
  margin: 10px 0;
}

.purchaseReceivingEdit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

// 加载效果水平垂直居中
.el-loading-spinner {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
}

// 标题
.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 5px;
}
.tableBox .el-form-item__content {
  margin-left: 0 !important;
}

.tableBox .el-form-item {
  margin-bottom: 0;
}

.tableBox .el-input--mini .el-input__inner {
  text-align: center;
}
</style>